import * as Yup from "yup";
import { toast } from "react-toastify";
import FormDefault from "../../components/Forms/FormDefault";
import { requestAuth } from "../../components/services/RequestService";
import dayjs from "dayjs";

const NewProcedure = (props) => {
  const { reload, onClose, isQuotation = false } = props;
  return (
    <div>
      <FormDefault
        tittle="Agregar nuevo trámite"
        fields={[
          {
            label: "Compañia",
            name: "CompanyId",
            typeInput: "select",
            urlApi: "/company/getallcompanies",
            value: "id",
            labelOption: "razonSocial",
          },
          {
            label: "Tipo de procedimiento",
            name: "ProcedureTypeId",
            typeInput: "select",
            urlApi: "/procedureType",
            value: "id",
            labelOption: "name",
          },
          {
            label: "Sucursal",
            name: "city",
            typeInput: "select",
            options: [
              {
                label: "La Paz",
                value: "LP",
              },
              {
                label: "Santa Cruz",
                value: "SC",
              },
            ],
          },
          {
            label: "Tipo de tramite",
            name: "Category",
            typeInput: "select",
            options: [
              {
                label: "Normal",
                value: "normal",
              },
              {
                label: "Multiple",
                value: "multiple",
              },
            ],
          },
          {
            label: "Cantidad de items",
            name: "numberItems",
            typeInput: "number",
            conditionType: "listValidate",
            reference: "Category",
            condition: "multiple",
          },
        ]}
        initialValues={{
          CompanyId: "",
          ProcedureTypeId: 1,
          city: "LP",
          year: dayjs().format("YYYY"),
          IsQuotation: isQuotation,
          Category: "normal",
          numberItems: 1,
        }}
        validationSchema={Yup.object().shape({
          CompanyId: Yup.string().required("Este campo es obligatorio"),
          ProcedureTypeId: Yup.string().required("Este campo es obligatorio"),
        })}
        onSubmit={async (values) => {
          await requestAuth(
            "post",
            isQuotation ? `/procedure/simple` : `/procedure`,
            values
          )
            .then(() => {
              reload();
              onClose();
              toast.success("Trámite agregado correctamente!!!");
            })
            .catch(() => {
              toast.error("Se ha producido un error al crear el Proceso");
            });
        }}
        buttonName="Enviar"
      />
    </div>
  );
};

export default NewProcedure;
